"use client";
import Link from "next/link";
import { ArrowRight, User, Cpu, Telescope, Activity } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { executiveTeam as data } from "@/lib/data/leadership";

const iconMap: Record<string, React.ComponentType<{ className?: string; style?: React.CSSProperties }>> = { User, Cpu, Telescope, Activity };
const accents = ["var(--color-crimson)", "var(--color-cyan)", "var(--color-purple)", "var(--color-emerald)"];

export function ExecutiveTeam() {
  return (
    <Section id="executive-team" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-cyan)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
            <p className="mt-5 text-body text-[rgb(var(--fg-muted))] leading-relaxed">{data.intro}</p>
          </div>
        </Reveal>
        <div className="mt-12 grid sm:grid-cols-2 gap-5">
          {data.executives.map((exec, i) => {
            const Icon = iconMap[exec.icon] ?? User;
            const accent = accents[i % accents.length]!;
            return (
              <Reveal key={exec.role} delay={i * 100}>
                <div className="glass rounded-2xl p-7 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
                  <div className="flex items-center gap-3">
                    <span className="grid place-items-center h-12 w-12 rounded-2xl" style={{ background: `color-mix(in oklch, ${accent} 18%, transparent)`, boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 35%, transparent)` }}>
                      <Icon className="h-5 w-5" style={{ color: accent }} />
                    </span>
                    <span className="eyebrow-tiny" style={{ color: accent }}>Executive</span>
                  </div>
                  <h3 className="mt-5">{exec.role}</h3>
                  <p className="mt-3 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{exec.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
        <Reveal delay={500}>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            {data.cta.map((c, i) => (
              <Link key={c.label} href={c.href} className={i === 0 ? "btn-primary-gradient h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm" : "btn-glass h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm"}>
                {c.label} <ArrowRight className="h-3.5 w-3.5" />
              </Link>
            ))}
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
